import { z } from 'zod';

export const pwlLabQuestCompleteSchema = z.object({
    questCompletedDate: z.string().min(1, 'Required'),
    questCompletedWhere: z.string().trim().min(1, 'Required'),
});
